import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initializeFacebookPixel } from "./lib/facebookPixel";
import { initChunkErrorHandler } from "./lib/chunkErrorHandler";

// Initialize chunk error handler FIRST (before any lazy loading can fail)
initChunkErrorHandler();

// Initialize Facebook Pixel
initializeFacebookPixel();

// Hide boot fallback once React mounts
const bootFallback = document.getElementById("boot-fallback");
if (bootFallback) {
  bootFallback.style.display = "none";
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Signal to prerenderer that the app has rendered
document.dispatchEvent(new Event("app-rendered"));
